import { Button } from 'primereact/button';
import { FC, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { Dropdown } from 'primereact/dropdown';
import { selectUser } from '../../redux/reducers/userSlice';
import { TargetGroup } from '../../models/TargetGroup';
import { selectedTargetGroup, setTargetGroup } from '../../redux/reducers/targetGroupSlice';
import { sortByKey } from '../../businessLogicService/sortCriteria';
import { DiagnosticUpsertStudentTargetGroupsForStudentMutation } from '../../graphQLOperations/__generated__/DiagnosticUpsertStudentTargetGroupsForStudentMutation.graphql';
import { useMutation } from 'react-relay';
import { upsertStudentTargetGroupsForStudent } from '../../graphQLOperations/Diagnostic';
import { isTargetGroupInSite } from '../../businessLogicService/isTargetGroupInSite';

interface Props {
  setShowDiagnostic: (value: boolean) => void;
}

export const DiagnosticFinished: FC<Props> = ({ setShowDiagnostic }) => {
  const dispatch = useAppDispatch();
  const userRedux = useAppSelector(selectUser);
  const targetGroupRedux = useAppSelector(selectedTargetGroup);
  const [roadmapDropdownValue, setRoadmapDropdownValue] = useState<{ id: string; name: string } | null>(null);

  const showDropdown = !isTargetGroupInSite(userRedux, targetGroupRedux) || !targetGroupRedux;

  const [upsertStudentTargetsMutation] = useMutation<DiagnosticUpsertStudentTargetGroupsForStudentMutation>(
    upsertStudentTargetGroupsForStudent,
  );

  const targetGroupsNodes =
    userRedux?.sites
      ?.map(
        site =>
          site?.targetGroups?.map(target => ({
            id: target?.id || '',
            name: target?.name || '',
          })) ?? [],
      )
      ?.flat() ?? [];

  let targetGroupTemplates = targetGroupsNodes?.map(target => ({ id: target?.id, name: target?.name }));
  targetGroupTemplates = [...targetGroupTemplates].sort(sortByKey('name'));

  useEffect(() => {
    if (!showDropdown) {
      setShowDiagnostic(false);
    }
  }, []);

  useEffect(() => {
    if (targetGroupTemplates.length === 1) {
      setRoadmapDropdownValue({ name: targetGroupTemplates[0].name, id: targetGroupTemplates[0].id });
    }
  }, [targetGroupTemplates]);

  const handleSubmit = () => {
    if (roadmapDropdownValue) {
      upsertStudentTargetsMutation({
        variables: {
          input: {
            studentTargetGroups: [
              {
                studentId: `StudentNode:${userRedux?.id}`,
                targetGroupId: roadmapDropdownValue?.id || '',
                isActive: true,
                isCurrent: true,
              },
            ],
          },
        },
      });

      dispatch(setTargetGroup(roadmapDropdownValue as TargetGroup));
    }

    setShowDiagnostic(false);
  };

  return (
    <div className="flex flex-column tw-mt-[10rem] align-items-center" style={{ fontFamily: 'Poppins' }}>
      <h3 className="font-semibold tw-mb-5">Please select your Roadmap and let your journey start!</h3>

      <Dropdown
        optionLabel="name"
        value={roadmapDropdownValue}
        onChange={e => setRoadmapDropdownValue(e.target.value)}
        options={targetGroupTemplates}
        placeholder="Choose a Roadmap"
        aria-label="Choose a Roadmap"
        className="tw-w-[90%] !tw-border-neutral-500"
      />

      <Button
        iconPos="right"
        className="tw-mt-6 tw-w-[50%] tw-h-[2.5rem]"
        label="Continue"
        onClick={handleSubmit}
        disabled={!roadmapDropdownValue?.id && !isTargetGroupInSite(userRedux, targetGroupRedux)}
        icon="nc_icon-nc_next icon-sm"
      />
    </div>
  );
};
